import { BehaviorSubject } from 'rxjs';
import Cookies from 'universal-cookie';

const APIURL = process.env.REACT_APP_API_URL;

const cookies = new Cookies();

const currentUser = {
    usuario: "",
    numeroidentificacion: "",
    roles: []
};

const currentUserSubject = new BehaviorSubject(currentUser);

export const authService = {
    loginWithMsal,
    logout,
    logoutWithMsal,
    validateToken,
    setGlobalFetch,
    currentUser: currentUserSubject.asObservable(),
    currentUserSubject,
    get currentUserValue() { return currentUserSubject.value },
};

function logout() {
    signout();
}

async function logoutWithMsal(msalInstance, accounts) {
    localStorage.setItem('app_logged_out', 'true');
    signout();

    try {
        if (accounts.length > 0) {
            await msalInstance.clearCache({ account: msalInstance.getActiveAccount() || accounts[0] });
        }
    } catch (error) {
        console.error('MSAL clearCache error:', error);
    }

    window.location.href = process.env.REACT_APP_BASE_URL || '/';
}

function signin(data) {

    if (data) {
        let signinUser = {
            usuario: data.netId,
            numeroidentificacion: data.numeroidentificacion,
            tipoidentificacion: data.tipoidentificacion,
            apellidos: data.apellidos,
            nombres: data.nombres,
            roles: data.roles,
            token: data.token,
            isImpersonated: false
        };

        cookies.set('authToken', signinUser.token, {
            path: '/'
        });
        cookies.remove('impersonateToken', { path: '/' });
        setGlobalFetch();
        currentUserSubject.next(signinUser);
    }

}

function validateToken(token, decodedToken, isImpersonating = false) {
    let signinUser = {
        usuario: decodedToken.username,
        numeroidentificacion: decodedToken.identificacion,
        tipoidentificacion: decodedToken.tipoidentificacion,
        apellidos: decodedToken.apellidos,
        nombres: decodedToken.nombres,
        roles: decodedToken.rolesObj
            ? Array.isArray(decodedToken.rolesObj)
                ? decodedToken.rolesObj.map(roleObj => {
                    const role = JSON.parse(roleObj);
                    return {
                        role: role.Role,
                        scope: role.Scope,
                        scopeName: role.ScopeName
                    };
                })
                : [JSON.parse(decodedToken.rolesObj)].map(roleObj => {
                    return {
                        role: roleObj.Role,
                        scope: roleObj.Scope,
                        scopeName: roleObj.ScopeName
                    };
                })
            : [],
        token: token,
        isImpersonated: isImpersonating
    };

    setGlobalFetch();
    currentUserSubject.next(signinUser);
}

function signout() {
    cookies.remove('authToken', { path: '/' });
    cookies.remove('impersonateToken', { path: '/' });
    currentUserSubject.next(null);
}

async function loginWithMsal(accessToken) {
    try {
        const response = await fetch(`${APIURL}/api/Account/login-entra-id`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });

        if (response.ok) {
            const data = await response.json();

            if (data.token && data.user) {
                const user = {
                    token: data.token,
                    netId: data.user.netId,
                    numeroidentificacion: data.user.numeroidentificacion,
                    tipoidentificacion: data.user.tipoidentificacion,
                    apellidos: data.user.apellidos,
                    nombres: data.user.nombres,
                    roles: data.user.roles || []
                };
                signin(user);
                return { success: true, user: data.user };
            } else {
                return { success: false, error: 'Invalid response structure' };
            }
        }

        const errorData = await response.json();
        return { success: false, error: errorData.message || 'Authentication failed' };
    } catch (error) {
        console.error('MSAL login error:', error);
        return { success: false, error: error.message || 'Network error' };
    }
}

let globalFetchInstalled = false;

function setGlobalFetch() {
    if (globalFetchInstalled) return;
    globalFetchInstalled = true;

    let realFetch = window.fetch;
    window.fetch = function (url, opts = null) {
        if (opts == null) opts = {};
        let headers = opts != null && opts.headers != undefined ? opts.headers : {};

        const token = cookies.get('impersonateToken') || cookies.get('authToken');

        if (token) {
            headers = Object.assign({}, headers, { 'Authorization': `Bearer ${token}` });

            if (url.indexOf('FileUpload') < 0 && headers['Content-Type'] == undefined) {
                headers = Object.assign({}, headers, { 'Content-Type': 'application/json' });
            }
            opts.headers = headers;
            return realFetch(url, opts);
        } else {
            return realFetch(url, opts);
        }
    };
}